var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#1075DD",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 25V26.2C31.5 27.8802 31.5 28.7202 31.173 29.362C30.8854 29.9265 30.4265 30.3854 29.862 30.673C29.2202 31 28.3802 31 26.7 31H18.3C16.6198 31 15.7798 31 15.138 30.673C14.5735 30.3854 14.1146 29.9265 13.827 29.362C13.5 28.7202 13.5 27.8802 13.5 26.2V25M27.5 18L22.5 13M22.5 13L17.5 18M22.5 13V25",
    stroke: "#1F44DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.c299660bc2c191b91488beeb0b8b4a36.svg";
export { ForwardRef as ReactComponent };